import React, { Component } from 'react';
import { AuthConsumer } from './AuthContext';

export class Page extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        const { name, title, content1, content2 } = this.props;

        let content2HTML = "";

        if(name === "about"){

            if(content2){
                content2HTML = (<div dangerouslySetInnerHTML={{__html: content2}}></div>);
            }

            return (
                <section className="contact-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="title">{title}</h3>
                                <div className="row">
                                    <div className="col-md-6" dangerouslySetInnerHTML={{__html: content1}}>
                                    </div>
                                    <div className="col-md-6">
                                        <img className='img-fluid' src='/images/aboutus1.jpg' />
                                    </div>
                                </div>
                                {content2HTML}
                            </div>
                            <div className="col-md-8">
                                <img className='img-fluid' src='/images/aboutus2.jpg' />
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <section className="contact-wrapper main-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className="title">{title}</h3>
                            <div dangerouslySetInnerHTML={{__html: content1}}>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export const GuestReadMore = () => (
    <section className="contact-wrapper">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="title">How to be a Guest</h3>
                    <p>
                        Freebird Club members are encouraged to connect with one another
                        through traveling from one home to another. By being a guest, you
                        can experience a new place through a local’s eyes, staying in a
                        comfortable environment. Each guest and host becomes acquainted
                        through finding accommodation on the Freebird Club website, ensuring
                        members’ experiences are tailored to their needs.{' '}
                    </p>

                    <p>
                        Guests and hosts can share stories, experiences, and even meals. The
                        Freebird Club stipulates that guests receive breakfast each morning
                        for the duration of their stay. This is included in the nightly
                        rate, which is paid when your booking is confirmed. This alleviates
                        any possible worry about having to pay during your trip. If anything
                        goes wrong, Freebird Club will of course be here to help.
                    </p>

                    <p>
                        If hosts and guests would like to share meals, we provide a space
                        for that to be communicated. Similarly, if a guest would like to
                        simply stay at a host’s home and explore the area themselves, or
                        like to spend time with their host, we provide a space for this to
                        be discussed. This way, all members know what to expect, and feel
                        comfortable at the host’s home before they even arrive.
                    </p>

                    <p>
                        Once you are a member of Freebird Club, you can search for
                        places you would like to visit at dates that suit. You may then look
                        through the various host profiles, ideally finding a like-minded
                        member to stay with, in a location that appeals to you.{' '}
                    </p>

                    <p>
                        The next step involves the guest sending an enquiry to a potential
                        host, perhaps sharing the nature of your trip. It is then up to the
                        host to send an invite to you, this may be instant or maybe after
                        getting to know you a little through Freebird messaging. When your
                        booking is confirmed, you will receive an SMS on your mobile phone.{' '}
                    </p>

                    <p>
                        We encourage both guest and host to communicate. This might be about
                        dietary or mobility requirements, or even just about the best way to
                        get to the host location. It’s important to ask any questions you
                        may have, helping your trip to run as smoothly as possible.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export const TrustReadMore = () => (
    <section className="contact-wrapper">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="title">Your Safety & Security</h3>
                    <p>
                        Freebird Club strives to create a real sense of trust and
                        security among our members, and the safety of our hosts and guests
                        is our number one priority. For this reason, all of our members are
                        checked and verified before any bookings can take place.
                    </p>

                    <p>
                        To join Freebird Club you are required to upload two
                        photographs: 1) A copy of a valid proof of identity document. This
                        may be a passport, national identity card or a driver’s licence. 2)
                        A photograph chosen to be your profile photo. This must include your
                        face.{' '}
                    </p>

                    <p>
                        The Freebird Club team manually checks that both the photo and date
                        of birth on the official identification corresponds to the profile
                        photo and the provided date of birth.
                    </p>

                    <p>
                        Freebird Club uses a highly secure user-friendly payment system
                        called Stripe. This system facilitates payment using members’ bank
                        or credit card details.
                    </p>

                    <p>
                        In joining Freebird Club, the team sends an email to the given
                        email address. This email seeks to confirm the address provided.
                        Upon completion of the joining process, an email confirming
                        membership to Freebird Club will also be sent.{' '}
                    </p>

                    <p>
                        As we prioritise the safety of all members, only first names are
                        visible on each members’ profile. To keep a host’s location private,
                        a map of the host’s general area is shown. When a booking is
                        confirmed, each party receives the other members full name and the
                        guest receives the host’s address. A host may share their phone
                        number with the guest if they wish to.
                    </p>

                    <p>
                        We currently store documents on Amazon. This storage complies with
                        the safe harbour regulations. All documents are encrypted, and only
                        accessible with private tokens dynamically generated. Please note
                        that documentation provided by members is never published on The
                        Freebird Club website.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export const HostReadMore = () => (
    <section className="contact-wrapper">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="title">How to be a Host</h3>
                    <p>
                        Hosting allows you to welcome other Freebird Club members into your
                        home. This gives you the opportunity to connect with like-minded
                        Freebirds, and providing guests with a comfortable base for the
                        duration of their trip. As a host, you can help a guest experience
                        your area with ease and a local’s knowledge. For this, you can
                        decide on a nightly rate to be charged. This payment will go through
                        24 hours after the guest arrives at your home.{' '}
                    </p>

                    <p>
                        If you choose to be a host, the Freebird Club website will function
                        to connect you with potential guests. This process has been tailored
                        to make things as effortless as possible.{' '}
                    </p>

                    <p>
                        Interested Freebird members will contact you, enquiring to stay in
                        your home. Freebird messaging has been set up so that each time you
                        receive a message on your Freebird profile, we will send you an
                        email notifying you.{' '}
                    </p>

                    <p>
                        After you receive an enquiry, you can become acquainted through
                        Freebird messaging, and find out about the interested guest’s plans
                        for the duration of their stay. As a host, you may like to share
                        more meals than breakfast with the guest, and even go sightseeing
                        together. We provide a space for each members wishes to be
                        communicated. If this suits you, you can extend an invitation, if
                        not, then that’s OK, too.{' '}
                    </p>

                    <p>
                        It is important that all Freebird members feel comfortable during
                        this process and so communication is key! In the time leading up to
                        your guests stay, make sure your guest has directions or the best
                        route to your home. Each member will also receive a booklet
                        outlining things to consider when hosting and being a guest in
                        someone’s home.{' '}
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export class LogOut extends Component {
    render() {
        return (
            <AuthConsumer>
                {({ handleLogout }) => <div>{handleLogout()}</div>}
            </AuthConsumer>
        );
    }
}

export class AdminLogOut extends Component {
    render() {
        return (
            <AuthConsumer>
                {({ handleEditorLogout }) => <div>{handleEditorLogout()}</div>}
            </AuthConsumer>
        );
    }
}
